module.exports = __webpack_public_path__ + "img/edit_pencil.00f268cc.svg";